import { useContext } from "react";
import { TaskCreationContext } from "../contexts/TaskCreationContext";

export function useTaskCreation() {
    return useContext(TaskCreationContext);
}